


































































































































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { Billing, DEFAULT_BILLING } from "@/model/agreement/billing";
import AuthMixin from "@/mixins/authMixin";
import RulesMixin from "#/mixins/rulesMixin";
import UtilMixin from "@/mixins/utilMixin";

@Component({})
export default class extends Mixins(AuthMixin, RulesMixin, UtilMixin) {
  /** 事業所請求情報 */
  @Prop({ default: () => DEFAULT_BILLING }) billing!: Billing;

  /** 確定済みフラグ */
  @Prop({ default: false }) confirmed!: boolean;

  /** 解約・停止系項目を触ることができるかフラグ */
  @Prop({ default: false }) canChangeStopInput!: boolean;

  private get IsAiOn(): boolean {
    return this.billing.is_bi_enabled == 1;
  }

  /** バリデーションチェック:開始日 */
  private checkStartDate(date: string): boolean | string {
    // 機能OFFの場合は必須なし
    if (!this.IsAiOn) {
      return true;
    }

    // 機能ONの場合は必須
    if (!date) {
      return "必須項目です。";
    }

    return true;
  }

  /** バリデーションチェック:バンドル適用開始日 */
  private checkBundleStartDate(): boolean | string {
    // 終了日のみはNG
    if (!this.billing.bi_bundle_start_date && this.billing.bi_bundle_end_date) {
      return "バンドル適用開始日を入力してください。";
    }

    return true;
  }

  /** 終了日(未反映)欄を終了欄に反映 */
  private async copyEndDatePendingToEndDate() {
    await this.$openAlert(
      "終了日欄に反映します。\n保存ボタンを押して変更を確定してください。"
    );
    this.billing.bi_end_date = this.billing.bi_end_date_pending;
  }

  /** オプション系リセット */
  private resetOption() {
    if (!this.billing.is_bi_enabled) {
      this.billing.is_biaggregate_enabled = 0;
    }
  }
}
